import React from 'react';
import styled from 'styled-components';

const PopoverContainer = styled.div`
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    background-color: white;
    border-radius: 6px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1), 0px 2px 2px 0px rgba(0, 0, 0, 0.03);
`;

const Triangle = styled.div`
    position: absolute;
    top: -5px;
    left: ${(props) => props.position};
    width: 11px;
    height: 11px;
    background-color: white;
    transform: rotate(45deg);
    border-radius: 1px;
`;

const BasicPopover = ({ className, width = '293', height = '60', children }) => {
    const position = (width / 2 - 5.5).toString().concat('px');
    return (
        <PopoverContainer className={className} width={width.concat('px')} height={height.concat('px')}>
            <Triangle position={position}></Triangle>
            {children}
        </PopoverContainer>
    );
};
export default BasicPopover;
